import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

// Chave pública do EMTUACASA
const stripePromise = loadStripe('pk_live_51E7r1yE0YzXWF5RLin5px6VCk3PjUYwqfaFcuvs86frdKi9uKhhzTYtWGWY6KxROeIX2Y3r00UbGTw7R5BV09yGr001IEaX7x2');

interface CardInputProps {
  onCardReady: (ready: boolean) => void;
  onError: (error: string | null) => void;
  onPaymentMethod: (paymentMethod: any) => void;
}

const CardInput = ({ onCardReady, onError, onPaymentMethod }: CardInputProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const [cardComplete, setCardComplete] = useState(false);

  useEffect(() => {
    onCardReady(!!stripe && !!elements && cardComplete);
  }, [stripe, elements, cardComplete]);

  const handleCreatePaymentMethod = async () => {
    if (!stripe || !elements) {
      throw new Error('Stripe não está inicializado');
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      throw new Error('Elemento do cartão não encontrado');
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      throw new Error(error.message);
    }

    onPaymentMethod(paymentMethod);
    return paymentMethod;
  };

  return (
    <div className="w-full">
      <CardElement
        options={{
          style: {
            base: {
              fontSize: '16px',
              color: '#424770',
              '::placeholder': {
                color: '#aab7c4',
              },
              backgroundColor: 'white',
            },
            invalid: {
              color: '#9e2146',
            },
          },
        }}
        onChange={(event) => {
          setCardComplete(event.complete);
          if (event.error) {
            onError(event.error.message);
          } else {
            onError(null);
          }
        }}
      />
      <button
        onClick={handleCreatePaymentMethod}
        disabled={!cardComplete}
        className={`mt-4 w-full py-2 px-4 rounded transition-colors ${
          !cardComplete
            ? 'bg-gray-300 cursor-not-allowed'
            : 'bg-primary text-white hover:bg-primary/90'
        }`}
      >
        Configurar Cartão
      </button>
    </div>
  );
};

interface StripeCardInputWrapperProps {
  onCardReady: (ready: boolean) => void;
  onError: (error: string | null) => void;
  onPaymentMethod: (paymentMethod: any) => void;
}

export default function StripeCardInputWrapper(props: StripeCardInputWrapperProps) {
  return (
    <Elements stripe={stripePromise}>
      <CardInput {...props} />
    </Elements>
  );
}
